import React, { PropTypes, Component } from 'react'
import { func } from 'prop-types'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'

import Loading from 'components/Loading'
import { fetchBilling } from 'containers/Billing/actions'

import Data from './data'

class Billing extends Component {

  constructor(props) {
    super(props)
    this.state = {
      data: fromJS({}),
    }
  }

  componentDidMount() {
    const { dispatch, params } = this.props
    dispatch(fetchBilling(params.studentID))
      .then((res) => {
        if (!res.error) {
          this.setState({
            data: fromJS(res.payload || {}),
          })
        }
      })
  }

  render() {
    const { __name } = this.props
    const { data } = this.state

    if (data.size === 0) {
      return <Loading />
    }

    return <Data data={data} name={__name} />
  }
}

Billing.propTypes = {
  __name: PropTypes.object,
  dispatch: func,
}

function mapStateToProps(state) {
  return {
    __name: state.auth.get('me'),
  }
}

export default connect(mapStateToProps)(Billing)



// WEBPACK FOOTER //
// ./src/containers/Print/Billing/index.js